import { ToolsRoutes } from "./names";

import type { AppRouteRecordRaw } from "@/app/router/types/types";

// An unnamed menu group, like `catalog`. Groups with no `menuOrder` keep the order of this array,
// so it sits after Catalog (see `routesToMenuItems`). The first page has an empty path so it opens
// at `/tools/competitors`; a child named `competitors` would give `/tools/competitors/competitors`.
export const competitorsRoutes: AppRouteRecordRaw[] = [
  {
    path: "competitors",
    meta: {
      isMenuParent: true,
      menuTitle: "Competitors",
      menuIcon: "lucide:swords",
    },
    children: [
      {
        path: "",
        name: ToolsRoutes.COMPETITORS_CATALOG,
        component: () => import("../../pages/competitors/CompetitorsCatalogPage.vue"),
        meta: {
          title: "Products & brands",
          pageKey: "ToolsCompetitorsCatalog",
          menuIcon: "lucide:package-search",
          menuOrder: 1,
        },
      },
      {
        path: "connections",
        name: ToolsRoutes.COMPETITORS_CONNECTIONS,
        component: () => import("../../pages/competitors/CompetitorConnectionsPage.vue"),
        meta: {
          title: "Connections",
          pageKey: "ToolsCompetitorsConnections",
          menuIcon: "lucide:link",
          menuOrder: 2,
        },
      },
    ],
  },
];
